import React from 'react'
import { Document, Font, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer'
import provinces from '../provinces.json'
import towns from '../towns.json'
import { useTranslation } from 'react-i18next';

export default function OfferLetter({ selection, choose, school }){
    const { t } = useTranslation()

    const BENEFITS = ["lifeOrAccidentsInsurance", "continuousFormation", "privateMedicalInsurance", "foodDiscounts", "emotionalWelfarePrograms", "schoolDiscounts", "sportsFacilitiesDiscounts", "otherBenefits"]
    const DOCUMENTATION = ["dni", "socialSecurity", "bankAccount", "photo", "foodHandlingCard", "sexualCrimeCertification", "workResidencyPermission", "workLifeReport", "otherDocumentation"]

    Font.register({
		family: 'Poppins',
		fonts: [
			{
			  	src: `/fonts/Poppins/Poppins-Regular.ttf`
			},
			{
			  	src: `/fonts/Poppins/Poppins-SemiBold.ttf`,
				fontWeight: 'semibold'
			},
			{
				src: `/fonts/Poppins/Poppins-Bold.ttf`,
				fontWeight: 'bold'
			}
		]
	})

    const styles = StyleSheet.create({
        page: {
            fontSize: 12,
            paddingVertical: 30,
            paddingHorizontal: 60,
            fontFamily: "Poppins"
        },
        logoView: {
            marginLeft: 415
        },
        logo: {
            width: 75,
        },
        headerDate: {
            fontSize: 8,
            marginTop: 10
        },
        headerSchoolName: {
            fontWeight: "bold",
            marginBottom: 10
        },
        headerSchoolInfo: {
            fontWeight: "bold",
            fontSize: 8
        },
        welcome: {
            marginTop: 20,
            marginBottom: 2
        },
        paragraph: {
            marginVertical: 10
        },
        bold: {
            fontWeight: "bold"
        },
        bulletListContainer: {
            display: "flex",
            flexDirection: "row"
        },
        bulletListElement: {
            marginRight: 10
        },
        subBulletList: {
            marginLeft: 10
        },
        signInfoName: {
            marginTop: 20,
            fontWeight: "bold"
        },
        footerContainer: {
            position: "absolute",
            bottom: 20,
            paddingHorizontal: 70
        },
        footer: {
            width: 450,
            borderTopWidth: 2,
            borderTopStyle: "solid",
            fontSize: 6,
            paddingTop: 10,
            textAlign: "center"
        }
    })
    return (
        <Document>
            <Page style={styles.page} size="A4">
                <View style={styles.logoView}>
                    <Image style={styles.logo} src={school?.image ? school?.image + "?v=1" : "/images/logotipo.png"}/>
                </View>
                <View style={styles.headerDate}>
                    <Text>{ new Date().toLocaleDateString() }</Text>
                </View>
                <View style={styles.headerSchoolName}>
                    <Text>{ school?.name }</Text>
                </View>
                <View style={styles.headerSchoolInfo}>
                    <Text>{ `${school?.address}, ${towns.find(t => t.value === school?.town)?.label} (${provinces.find(t => t.value === school?.province)?.label})` }</Text>
                </View>
                {
                    school?.phone &&
                    <View style={styles.headerSchoolInfo}>
                        <Text>{ school?.phone }</Text>
                    </View>
                }
                {
                    school?.emailcontact &&
                    <View style={styles.headerSchoolInfo}>
                        <Text>{ school?.emailcontact }</Text>
                    </View>
                }
                {
                    school?.web &&
                    <View style={styles.headerSchoolInfo}>
                        <Text>{ school?.web }</Text>
                    </View>
                }
                <View style={styles.welcome}>
                    <Text>
                        {
                            choose?.candidate?.sex === "M"
                            ?
                                t("selection.offerLetterFile.maleWelcome", { name:  choose?.candidate?.firstname})
                            :
                                t("selection.offerLetterFile.femaleWelcome", { name:  choose?.candidate?.firstname})
                        }
                    </Text>
                </View>
                <View style={styles.paragraph}>
                    <Text>{t("selection.offerLetterFile.opening", { school: school?.name, title: selection?.title })}</Text>
                </View>
                <View style={styles.paragraph}>
                    <Text style={styles.bold}>{t("selection.offerLetterFile.offerDetails")}</Text>
                </View>
                <View style={styles.bulletListContainer}>
                    <Text style={styles.bulletListElement}>•</Text>
                    <Text>{ selection?.title }</Text>
                </View>
                <View style={styles.bulletListContainer}>
                    <Text style={styles.bulletListElement}>•</Text>
                    <Text>{`${ selection?.incorporationDate ? new Date(selection?.incorporationDate).toLocaleDateString() : ""}${selection?.endReplacementDate ? ` - ${new Date(selection?.endReplacementDate).toLocaleDateString()}` : ""}`}</Text>
                </View>
                <View style={styles.bulletListContainer}>
                    <Text style={styles.bulletListElement}>•</Text>
                    <Text>{ `${school?.address}, ${towns.find(t => t.value === school?.town)?.label} (${provinces.find(t => t.value === school?.province)?.label})` }</Text>
                </View>
                <View style={styles.bulletListContainer}>
                    <Text style={styles.bulletListElement}>•</Text>
                    <Text>{t("selection.contractType")}: {t("profile.candidate." + selection?.contractType)}</Text>
                </View>
                <View style={styles.bulletListContainer}>
                    <Text style={styles.bulletListElement}>•</Text>
                    <Text>{(t('selection.salary'))}: {selection?.miniumSalary ? selection.miniumSalary : t('selection.byAgreement')}</Text>
                </View>
                {
                    BENEFITS.some(b => choose?.offerLetter && choose?.offerLetter[b]) &&
                    <>
                        <View style={styles.bulletListContainer}>
                            <Text style={styles.bulletListElement}>•</Text>
                            <Text>{(t('selection.benefits'))}:</Text>
                        </View>
                        <View style={styles.subBulletList}>
                            {
                                BENEFITS.filter(b => choose?.offerLetter && choose?.offerLetter[b]).map((benefit, index) => (
                                    <View key={index} style={styles.bulletListContainer}>
                                        <Text style={styles.bulletListElement}>-</Text>
                                        <Text>
                                            {
                                                benefit === "otherBenefits"
                                                ?
                                                    choose.offerLetter.otherBenefits
                                                :
                                                    (t('selection.offerLetterFields.' + benefit))
                                            }
                                        </Text>
                                    </View> 
                                ))
                            }
                        </View>
                    </>
                }
                <View style={styles.paragraph}>
                    <Text>{t("selection.offerLetterFile.paragraph1")}</Text>
                </View>
                <View style={styles.paragraph}>
                    <Text>{t("selection.offerLetterFile.documentation")}</Text>
                </View>
                {
                    DOCUMENTATION.filter(b => choose?.offerLetter && choose?.offerLetter[b]).map((benefit, index) => (
                        <View key={index} style={styles.bulletListContainer}>
                            <Text style={styles.bulletListElement}>•</Text>
                            <Text>
                                {
                                    benefit === "otherDocumentation"
                                    ?
                                        choose.offerLetter.otherBenefits
                                    :
                                        (t('selection.offerLetterFields.' + benefit))
                                }
                            </Text>
                        </View> 
                    ))
                }
                <View style={styles.paragraph}>
                    <Text>{t("selection.offerLetterFile.paragraph2")}</Text>
                </View>
                <View style={styles.paragraph}>
                    <Text>{t("selection.offerLetterFile.paragraph3", { school: school?.name })}</Text>
                </View>
                {/* <View style={styles.paragraph}>
                    <Text>{t("selection.offerLetterFile.paragraph4", { name: school?.contact, charge: school?.contact_charge, phone: school?.phone, email: school?.emailcontact })}</Text>
                </View> */}
                <View style={styles.paragraph}>
                    <Text>{t("selection.offerLetterFile.paragraph5")}</Text>
                </View>
                <View style={styles.paragraph}>
                    <Text>{t("selection.offerLetterFile.goodbye")}</Text>
                </View>
                {/* <View style={styles.signInfoName}>
                    <Text>{school?.contact}</Text>
                </View>
                <View>
                    <Text>{school?.contact_charge}</Text>
                </View> */}
                <View>
                    <Text>{school?.name}</Text>
                </View>
                <View style={styles.footerContainer}>
                    <View style={styles.footer}>
                        <Text>{t("selection.offerLetterFile.footer")}</Text>
                    </View>
                </View>
            </Page>
        </Document>
    )
}
